import { ApolloError, useQuery } from '@apollo/client';

import { StaticFilters } from '../../../pages/baymax/types/reports';
import { DateRange, GetReportStatisticsQuery, GetReportStatisticsQueryVariables, ReportStatistics } from '../types';
import { REPORT_STATISTICS } from './reportStatistics';
import { getCampaignIds, getDateForStatistics } from './utils/utils';

type useReportStatisticsType = {
  data?: ReportStatistics;
  loading: boolean;
  error?: ApolloError;
};

const useReportStatistics = (orgId: string, staticFilters: StaticFilters): useReportStatisticsType => {
  const { data, loading, error } = useQuery<GetReportStatisticsQuery, GetReportStatisticsQueryVariables>(
    REPORT_STATISTICS,
    {
      variables: {
        dateRange: staticFilters.dateRange as DateRange,
        startDate: getDateForStatistics(staticFilters.dateRange, staticFilters.startDate),
        endDate: getDateForStatistics(staticFilters.dateRange, staticFilters.endDate),
        organizationId: orgId,
        campaignIds: getCampaignIds(staticFilters.campaigns),
      },
    }
  );

  return {
    data: data?.getReportStatistics,
    loading,
    error,
  };
};

export default useReportStatistics;
